import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  profileData = signal<any>({
    profileCOmpletionProgress: 20,
    basicProfile: {
      isCompleted: false,
      isEditing: false,
    },
    advancedProfile: {
      isCompleted: false,
      isEditing: false,
    },
    companyProfile: {
      isCompleted: false,
      isEditing: false,
    },
    profileSettings: {
      isCompleted: false,
      isEditing: false,
    },
  });

  constructor () { }

  // Get the profile completion progress
  getProfileCompletionProgress (): number {
    return this.profileData().profileCOmpletionProgress;
  }

  // Set the profile completion progress
  setProfileCompletionProgress (progress: number): void {
    this.profileData.set({ ...this.profileData(), profileCOmpletionProgress: progress });
  }

  // Get the basic profile editing state
  getBasicProfileEditingState (): boolean {
    return this.profileData().basicProfile.isEditing;
  }

  // Set the basic profile editing state
  setBasicProfileEditingState (isEditing: boolean): void {
    this.profileData.set({ ...this.profileData(), basicProfile: { ...this.profileData().basicProfile, isEditing } })
  }
}
